import { render, staticRenderFns } from "./agentApproval.vue?vue&type=template&id=b29f8aee&scoped=true&"
import script from "./agentApproval.vue?vue&type=script&lang=ts&"
export * from "./agentApproval.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29f8aee",
  null
  
)

export default component.exports